import { PickersDay, PickersDayProps } from "@mui/x-date-pickers";

type CustomPickerDayProps = PickersDayProps<Date> & { selectedDays?: Date[] };
export function CustomPickerDay(props: CustomPickerDayProps) {
  const { day, selectedDays, ...otherProps } = props;
  const selected = selectedDays?.some((selectedDay) => {
    return selectedDay.toDateString() === day.toDateString();
  });

  return <PickersDay {...otherProps} day={day} selected={selected} />;
}
